import styles from './styles/PartnerValueProp.css'
import Header from '../typography/Header'
import Button from '../forms/Button'
import { useHistory } from 'react-router-dom'
import Link from '../misc/Link'

const PartnerValueProp = ({ children, id, link, linkLocation, cta, ctaLocation, illo, header, subheader, className }) => {
  const history = useHistory()
  return (
    <div id={id} className={`${styles.layout} ${className}`}>
      {illo && <img loading='lazy' alt={header} src={illo} />}
      <Header className={styles.header} level={3}>{header}</Header>
      {subheader && <span className={styles.subheader}>{subheader}</span>}
      <div className={styles.content}>
        {children}
        {cta && <Button color='blue' className={styles.submitBtn} onClick={() => history.push(ctaLocation)}>{cta}</Button>}
        {link && linkLocation && <Link target='_blank' rel='noopener noreferrer' className={styles.link} href={linkLocation}>{link}</Link>}
      </div>
    </div>
  )
}

export default PartnerValueProp
